import React from 'react';
import { Snackbar, makeStyles } from '@material-ui/core';
import MuiAlert from '@material-ui/lab/Alert';
import { useNotifications } from 'services/providers/notification-provider';

const useStyles = makeStyles((theme) => ({
  alertSuccess: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
  }
}));

export default function NotificationToast() {
  const classes = useStyles();
  const { newNotification } = useNotifications();
  const [open, setOpen] = React.useState(false);
  const [currentNotif, setCurrentNotif] = React.useState(null);
  const browserNotificationRef = React.useRef(null);

  const showBrowserNotification = React.useCallback((notif) => {
    if (!notif || typeof window === "undefined" || !("Notification" in window)) {
      return;
    }

    const launchNotification = () => {
      try {
        if (browserNotificationRef.current) {
          browserNotificationRef.current.close();
        }

        const title = notif.title || "Nouvelle notification";
        const body = notif.message || "";
        browserNotificationRef.current = new window.Notification(title, {
          body,
          icon: `${window.location.origin}/favicon.ico`,
          tag: `notification-${notif.id || Date.now()}`,
          renotify: true,
        });
      } catch (error) {
        // Fallback silencieux vers le Snackbar React
      }
    };

    if (window.Notification.permission === "granted") {
      launchNotification();
      return;
    }

    if (window.Notification.permission === "default") {
      window.Notification.requestPermission().then((permission) => {
        if (permission === "granted") {
          launchNotification();
        }
      });
    }
  }, []);

  React.useEffect(() => {
    if (newNotification) {
      setCurrentNotif(newNotification);
      setOpen(true);
      showBrowserNotification(newNotification);
    }
  }, [newNotification, showBrowserNotification]);

  React.useEffect(() => {
    return () => {
      if (browserNotificationRef.current) {
        browserNotificationRef.current.close();
      }
    };
  }, []);

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') return;
    setOpen(false);
  };

  const getSeverity = (status) => {
    if (status === 'SUCCESS') return 'success';
    if (status === 'FAILURE') return 'error';
    return 'info';
  };

  return (
    <Snackbar 
      open={open} 
      autoHideDuration={6000} 
      onClose={handleClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
    >
      <div>
        {currentNotif && (
          <MuiAlert 
            elevation={6} 
            variant="filled" 
            onClose={handleClose} 
            severity={getSeverity(currentNotif.status)}
            className={currentNotif.status === 'SUCCESS' ? classes.alertSuccess : ''}
            style={{ whiteSpace: 'pre-wrap' }}
          >
            <strong>{currentNotif.title}</strong>: {currentNotif.message}
          </MuiAlert>
        )}
      </div>
    </Snackbar>
  );
}
